export const giftback = {
	giftbacks: {
		title: "Campañas de giftback",
		description: "Crea y gestiona tus campañas de giftback.",
		createGiftback: "Crear giftback",
		searchPlaceholder: "Buscar por nombre de campaña",
		deleteConfirm: "¿Estás seguro de querer eliminar el giftback?",
		deleteGiftback: "Eliminar giftback",
		steps: {
			general: {
				title: "Configuración general",
			},
			resume: {
				title: "Resumen",
			},
		},
		emptyState: {
			title: "No encontramos lo que buscas",
			description:
				"Intenta seleccionar una nueva ubicación o período, o inténtalo de nuevo más tarde.",
		},
		buttonsTitle: {
			createAndActivateLater: "Crear y activar después",
			createAndActivateNow: "Crear y activar giftback",
			saveChanges: "Guardar cambios",
		},
		feedbackerros: {
			selectAtLeastOnePlace: "Seleccione al menos un local",
			maxCharactersName: "Máximo de 50 caracteres",
		},
		form: {
			active: "Activar giftback",
			name: "Nombre de la campaña",
			namePlaceHolder: "Ingrese el nombre de la campaña",
			minimumConsumptionLabel: "Valor mínimo de consumo",
			minimumConsumptionTooltip:
				"Valor que el cliente debe consumir para convertir en giftback.",
			percentageLabel: "Porcentaje",
			percentageTooltip:
				"Cuánto del valor consumido por el cliente será obsequiado al mismo.",
			expiresInLabel: "Plazo para expirar el giftback",
			expiresInTooltip:
				"Cantidad máxima de días en que el cliente debe utilizar el giftback.",
			expiresInPlaceholder: "Seleccione el plazo para expirar el giftback",
			expiresAtLabel: "Período del canje",
			expiresAtTooltip: "Tiempo que el cliente tendrá para aprovechar el giftback.",
			expiresAtPlaceholder: "Seleccione el período de validez del giftback",
			placeLabel: "Locales participantes",
			removeGiftback: "Eliminar giftback",
			selectAll: "Seleccionar todos",
			day: "día",
			days: "días",
			week: "semana",
			noValidity: "Sin validez",
			selectAllPlacesDescription:
				"Seleccione los locales donde el giftback estará disponible.",
		},
		tabs: {
			addNewGiftback: "Agregar nuevo giftback",
		},
	},
	giftbackReport: {
		selectGiftbackLabel: "Campaña",
		selectGiftbackPlacholder: "Seleccione la(s) campaña(s)",
		table: {
			createdAt: "Creado en",
			giftback: "Campaña",
			messagesSent: "SMS enviados",
			places: "Locales",
			rescues: "Canjes",
			totalValue: "{{ currencySymbol }} en ventas",
			giftbackSent: "Total de giftbacks",
			giftbackValue: "{{ currencySymbol }} giftback canjeado",
			conversionRate: "Tasa de conversión",
		},
		title: "Informe de canjes",
		totalizers: {
			quantity: "Campañas creadas",
			totalSms: "Total de SMS creados",
			totalRescues: "Total de canjes",
			totalSales: "Total en ventas utilizando giftback",
		},
	},
	giftbackPowerBi: {
		title: "Informe de Giftback",
	},
};
